<template>
  <v-flex
    id="firstMeeting"
    class="question"
  >
    <h2 class="header">
      {{ getFirstMeetingQuestions.label }}
    </h2>
    <ul class="questions-list">
      <li
        v-if="getFirstMeetingQuestions.hasOwnProperty('asked_questions')"
        class="mt-4"
      >
        <p
          class="header mb-1"
          :class="{ required: getFirstMeetingQuestions.asked_questions.required }"
        >
          {{ getFirstMeetingQuestions.asked_questions.label }}
        </p>
        <ConfirmButtons
          v-model="askedQuestions"
          v-validate="{ required: getFirstMeetingQuestions.asked_questions.required }"
          string
          :error-messages="errors.collect('askedQuestions')"
          :data-vv-as="' '"
          :data-vv-name="'askedQuestions'"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="askedQuestions === 'yes' && getFirstMeetingQuestions.hasOwnProperty('questions_list')"
        class="mt-4"
      >
        <p
          class="header custom lA"
          :class="{ required: getFirstMeetingQuestions.questions_list.required }"
        >
          {{ getFirstMeetingQuestions.questions_list.label }}
        </p>
        <v-textarea
          v-model="questionsList"
          v-validate="{ ...requiredRegularField(getFirstMeetingQuestions.questions_list.required) }"
          :error-messages="errors.collect('first_meeting')"
          :data-vv-as="' '"
          :data-vv-name="'first_meeting'"
          :required="getFirstMeetingQuestions.questions_list.required"
          :placeholder="$t('sheet.enter_text')"
          auto-grow
          :disabled="readOnly"
        />
      </li>
    </ul>
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';

import validationRules from '@/constants/validationRules';
import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';

import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

const { mapFields } = createHelpers({
    getterType: 'sheet/getFirstMeetingField',
    mutationType: 'sheet/updateFirstMeetingField'
});

export default {
    name: 'FirstMeeting',
    components: {
        ConfirmButtons
    },
    mixins: [sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            validationRules
        };
    },
    watch: {
        askedQuestions (val) {
            if (val === 'no') {
                this.questionsList = null;
            }
        }
    },
    computed: {
        ...mapFields(['askedQuestions', 'questionsList']),
        ...mapGetters('sheet', ['getFirstMeetingQuestions'])
    }
};
</script>

<style scoped></style>
